import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { ProductType } from "@obg/core.config";
import { CookieService } from "@obg/ngx.global";

import { CORE_ROUTE } from "../route";

import { PRODUCT_TYPE_COOKIE_NAME } from "./last-visited-prodcut.const";

@Injectable({
	providedIn: "root",
})
export class LastVisitedProductService {
	constructor(
		private cookieService: CookieService,
		private location: Location
	) {}

	getProductType(): ProductType | undefined {
		return this.cookieService.get(PRODUCT_TYPE_COOKIE_NAME) as ProductType;
	}

	setProductType(productType: ProductType) {
		this.cookieService.set({
			name: PRODUCT_TYPE_COOKIE_NAME,
			value: productType,
		});
	}

	getRouteName(): string | undefined {
		const productType = this.getProductType();

		if (!productType || this.location.path()) {
			return undefined;
		}

		return this.getRoute(productType);
	}

	private getRoute(productType: ProductType): string | undefined {
		switch (productType) {
			case ProductType.Casino:
				return CORE_ROUTE.lobbies.casino;
			case ProductType.LiveCasino:
				return CORE_ROUTE.lobbies.livecasino;
			case ProductType.Sportsbook:
				return CORE_ROUTE.lobbies.sportsbook;
			case ProductType.VirtualSports:
				return CORE_ROUTE.lobbies.virtualSports;
			// HorseRacing is a MFE and we can't handle SSR navigation for them at this point.
			// case ProductType.HorseRacing:
			// 	return CORE_ROUTE.lobbies.horseRacing;
			default:
				return undefined;
		}
	}
}
